import {MutationUpdateGatewayRoutingArgs} from "@/api";
import {PrivateRoutingQuery} from "@/components/gateway/routing/queries.generated";

export function createInitialData(
    domainId: number,
    gatewayRoutings?: PrivateRoutingQuery,
): MutationUpdateGatewayRoutingArgs {
    if (!gatewayRoutings)
        return {
            domainId: 0,
            gatewayRoutings: [
                {
                    comment: "",
                    destinationId: 0,
                    gatewayId: 0,
                    id: 0,
                    lastCallDirection: "",
                    lastCallTime: "",
                    priority: 1,
                },
            ],
        };

    return {
        domainId: domainId,
        gatewayRoutings: gatewayRoutings.privateRouting.items.map((r) => ({
            id: r.id,
            gatewayId: r.gateway.id,
            destinationId: r.destination.id,
            priority: r.priority,
            lastCallDirection: r.gateway.lastCallDirection,
            lastCallTime: r.gateway.lastCallTime,
            comment: r.comment,
        })),
    };
}
